"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTableSections = createTableSections;
/**
 * Creates a grouped data array with section headers for Table component
 * @param groups An object mapping section labels to arrays of data
 * @param sectionIdPrefix A prefix to use for section IDs
 * @returns An array with section titles and data
 */
function createTableSections(groups, sectionIdPrefix = 'section') {
    const result = [];
    Object.entries(groups).forEach(([sectionLabel, items]) => {
        if (items.length > 0) {
            // Add a section title
            result.push({
                id: `${sectionIdPrefix}-${sectionLabel}`,
                isSectionTitle: true,
                label: sectionLabel
            });
            // Add the items
            result.push(...items);
        }
    });
    return result;
}
